import { useCarousel } from 'nuka-carousel';

const useCarouselFix = useCarousel;

export default useCarouselFix;
